import { gql } from "@apollo/client"
import { updateUser, updateUserVariables, updateUser_updateUser } from "./types/updateUser"

export const UPDATE_USER_MUTATION = gql`
  mutation updateUser(
    $email: String!
    $firstName: String!
    $lastName: String!
    $role: UserRole!
    $townIds: [ID!]!
    $associationIds: [ID!]!
    $districtIds: [ID!]!
    $guidedDriverLocationIds: [ID!]!
    $collection_partner_id: ID
  ) {
    updateUser(
      email: $email
      firstName: $firstName
      lastName: $lastName
      role: $role
      townIds: $townIds
      associationIds: $associationIds
      districtIds: $districtIds
      guidedDriverLocationIds: $guidedDriverLocationIds
      collection_partner_id: $collection_partner_id
    ) {
      id
      first_name
      last_name
      role
      email
      collection_partner {
        id
        name
      }
    }
  }
`

export type UpdateUserResult = updateUser
export type UpdateUser = updateUser_updateUser
export type UpdateUserVariables = updateUserVariables
